module.exports = __webpack_public_path__ + "img/9788996898412.e603e4a8.jpg";